<template>
  <c-dialog ref="dialog" height="350" width="600" @resolve="editHandle">
    <c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="分类" required tip="请选择分组关联分类">
        <c-select name="category_id" async @search="searchCategory" :value-data="selectedCategory"></c-select>
      </c-form-item>
      <c-form-item label="分组名称" required tip="分组名称不允许重复">
        <c-input name="group_name" maxlength="50"></c-input>
      </c-form-item>
      <c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
      </c-form-item>
    </c-form>
  </c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
  computed: {
  },

  data() {
    return {
      editState: false,
      selectedCategory:[] //已选中的分类
    }
  },

  methods: {
    /*******搜索分类*****************/
    searchCategory(keyword, resolve){
      this.request({
        url:'/spu/category/options',
        data: {
          keyword: keyword
        },
        success:data => {
            resolve(data);
        }
      })
    },
    /*********打开编辑框，初始化**********/
    open(data) {
      this.editState = !!data;
      this.$refs.form.clear();
      if (data) {
        //已选中的[分类]
        this.selectedCategory = [{
          name: data.category_name,
          value:data.category_id
        }];
        this.$refs.form.set(data);
      }
      //填充form表单
      this.$refs.dialog.open({
        title: data ? '编辑质检分组' : '添加质检分组'
      });
    },

    /*******添加、编辑提交处理方法********/
    editHandle (stop, next){
      stop();
      this.$refs.form.submit({
        url: this.editState?'/spu/release/group/edit':'/spu/release/group/add',
        rule: {
          category_id: '请选择分组关联的分类',
          group_name: '请输入分组名称'
        },
        dataFormatter: data => {
          return data;
        },
        success: (data, res) => {
          next();
          if(this.editState){
            this.$message({
              message: '编辑成功',  // 提示内容,
              type: 'success'
            });
          }else{
            this.$message({
              message: '添加成功',  // 提示内容,
              type: 'success'
            });
          }
          this.$emit('resolve');
        }
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>